module.exports = {
      id: "angle-left-usage",
      viewBox: "0 0 192 512",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#angle-left",
      toString: function () {
        return this.url;
      }
    }